import { lazyNamed } from 'src/utils/lazyNamed';

const PrintOperations = {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  PrintLayout: lazyNamed(() => import('./containers/Print'), 'Layout'),
  PrintPage: lazyNamed(() => import('./containers/Print/PrintPage'), 'PrintPage'),
  PublicationUpload: lazyNamed(() => import('./containers/PublicationUpload'), 'PublicationUpload'),
};

export default PrintOperations;
